'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _FieldsetContext = require('../context/FieldsetContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LABEL_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__label--small'
};

var UIFormLabel = _react2.default.forwardRef(function (props, ref) {
  var className = props.className,
      error = props.error,
      readOnly = props.readOnly,
      required = props.required,
      rest = _objectWithoutProperties(props, ['className', 'error', 'readOnly', 'required']);

  var _useContext = (0, _react.useContext)(_FieldsetContext.FieldsetContext),
      fieldSize = _useContext.size;

  /* eslint-disable jsx-a11y/label-has-associated-control */


  return _react2.default.createElement('label', _extends({}, rest, {
    className: (0, _classnames2.default)('private-form__label', LABEL_SIZE_OPTIONS[fieldSize], className, {
      'private-form__label--readonly': readOnly,
      'private-form__label--required': required,
      'error-msg': error
    }),
    ref: ref
  }));
  /* eslint-enable jsx-a11y/label-has-associated-control */
});

UIFormLabel.propTypes = {
  children: _propTypes2.default.node,
  error: _propTypes2.default.bool.isRequired,
  htmlFor: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool.isRequired,
  required: _propTypes2.default.bool.isRequired
};

UIFormLabel.defaultProps = {
  error: false,
  required: false,
  readOnly: false
};

UIFormLabel.displayName = 'UIFormLabel';

exports.default = UIFormLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/form/UIFormLabel.js
// module id = 575
// module chunks = 177